import axiosInstance from './axiosInstance'

export const postFacesheet = async (data) => {
  try {
    const res = await axiosInstance.post('/map/facesheet', data)
    return res
  } catch (error) {
    throw error
  }
}

export const getFacesheet = async (data) => {
  try {
    const res = await axiosInstance.post('/map/facesheet/getanswers', data)
    return res
  } catch (error) {
    throw error
  }
}

export const nextFacesheet = async (page) => {
  try {
    const res = await axiosInstance.get(`map/facesheet/nextpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const backFacesheet = async (page) => {
  try {
    const res = await axiosInstance.get(`/map/facesheet/backpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const postIntake = async (data) => {
  try {
    const res = await axiosInstance.post('/map/intake', data)
    return res
  } catch (error) {
    throw error
  }
}

export const getIntake = async (data) => {
  try {
    const res = await axiosInstance.post('/map/intake/getanswers', data)
    return res
  } catch (error) {
    throw error
  }
}

export const nextIntake = async (page) => {
  try {
    const res = await axiosInstance.get(`map/intake/nextpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const nextSaymoreIntake = async (page) => {
  try {
    const res = await axiosInstance.get(`/map/intake/saymore/nextpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const backIntake = async (page) => {
  try {
    const res = await axiosInstance.get(`/map/intake/backpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const postPresection = async (data) => {
  try {
    const res = await axiosInstance.post('/map/presection', data)
    return res
  } catch (error) {
    throw error
  }
}

export const getPresection = async (data) => {
  try {
    const res = await axiosInstance.post('/map/presection/getanswers', data)
    return res
  } catch (error) {
    throw error
  }
}

export const nextPresection = async (page) => {
  try {
    const res = await axiosInstance.get(`/map/presection/nextpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const backPresection = async (page) => {
  try {
    const res = await axiosInstance.get(`/map/presection/backpageno/${page}`)
    return res
  } catch (error) {
    throw error
  }
}

export const getMapDetails = async () => {
  try {
    const res = await axiosInstance.get(`/client/mapdetails`)
    return res
  } catch (error) {
    throw error
  }
}
export const allowPresection = async () => {
  try {
    const res = await axiosInstance.get(`/client/allowpresection`)
    return res
  } catch (error) {
    throw error
  }
}

export const sectionPage = async (lang) => {
  try {
    const res = await axiosInstance.get(`/map/sectionindex/${lang}`)
    return res
  } catch (error) {
    throw error
  }
}

export const postConclusion = async (data) => {
  const lang = {
    languageId: data,
  }
  try {
    const res = await axiosInstance.post('/map/complete', lang)
    return res
  } catch (error) {
    throw error
  }
}

export const getMapResponses = async (questionId, languageId) => {
  const url = `/map/selectedresponses/${questionId}/${languageId}`
  try {
    const res = await axiosInstance.get(url)
    return res
  } catch (error) {
    return error?.response?.data
  }
}

export const getConclusion = async (languageId) => {
  const url = `/client/conclusion/${languageId}`
  try {
    const res = await axiosInstance.get(url)
    return res?.data
  } catch (error) {
    return error?.response?.data
  }
}
export const getProfessionals = async (languageId) => {
  const url = `/map/professionals/${languageId}`
  try {
    const res = await axiosInstance.get(url)
    return res?.data
  } catch (error) {
    throw error
  }
}
export const deleteProfessionals = async (submittedId) => {
  const url = `/map/professionals/${submittedId}`
  try {
    const res = await axiosInstance.delete(url)
    let data = {}
    if (res.status === 200) data = { success: true }
    return data
  } catch (error) {
    return { success: false }
  }
}
export const postProfessionals = async (body) => {
  const url = `/map/professionals`
  try {
    const res = await axiosInstance.post(url, body)
    return res.data
  } catch (error) {
    return error
  }
}

export const deleteClient = async () => {
  const url = `/map/delete`
  try {
    const res = await axiosInstance.delete(url)
    let data = {}
    if (res.status === 200) data = { success: true }
    return data
  } catch (error) {
    return { success: false }
  }
}

export const getProfile = async () => {
  const url = `/client/profile`
  try {
    const res = await axiosInstance.get(url)
    return res?.data
  } catch (error) {
    throw error
  }
}

export const updateProfile = async (body) => {
  let res = ''
  try {
    let url = `/client/profile`
    res = await axiosInstance.post(url, body)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const clientChangePwd = async (data) => {
  try {
    const res = await axiosInstance.post('/client/changepwd', data)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const getReport = async (type, languageId) => {
  try {
    const res = await axiosInstance.get(`/map/${type}/${languageId}`, { responseType: 'blob' })
    return res?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const getMessages = async () => {
  try {
    const res = await axiosInstance.get('/map/messages')
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const postMessages = async (data) => {
  try {
    const res = await axiosInstance.post('/map/messages', data)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}
